import React, { useEffect, useState } from 'react';
import Loader from '../../lib/components/Loader';

import api from '../../utils/api';

const Payouts = () => {
    const [loading, updateLoading] = useState(true);
    const [payouts, updatePayouts] = useState(null);
    const [totalPayouts, updateTotalPayouts] = useState(null);
    const [managers, updateManagers] = useState(null);
    
    const [sortByDirection, updateSortByDirection] = useState(null);

    useEffect(() => {
        Promise.all([api.get('/api/v1/history/payouts/years'), api.get('/api/v1/history/payouts/totals')]).then(([ { data: payouts }, { data: payoutsTotals} ]) => {
            updatePayouts(payouts);
            updateTotalPayouts(payoutsTotals);
            updateManagers(Object.keys(payoutsTotals));
            
            updateLoading(false);
        });
    }, []);

    const sortManagersTotals = () => {
        const sorted = managers.sort((a, b) => { return sortByDirection ? totalPayouts[a] - totalPayouts[b] : totalPayouts[b] - totalPayouts[a]});
        updateSortByDirection(!sortByDirection);
        updateManagers([...sorted]); // why?
    };

    const sortByYear = (year) => () => {
        const sorted = managers.sort((a, b) => { return sortByDirection ? payouts[year][a] - payouts[year][b] : payouts[year][b] - payouts[year][a]});
        updateSortByDirection(!sortByDirection);
        updateManagers([...sorted]); // why?
    };

    const sortedPayoutYears = payouts ? Object.keys(payouts).sort((a, b) => b - a) : [];

    return (
        <div className="seasonContainer sectionContainer">
            <h2>Payout History</h2>
            { loading ? <Loader/> :
                <div className='table-responsive'>
                    <table className="table table-dark table-striped">
                        <caption className="caption-top">*All columns are sortable</caption>
                        <thead>
                            <tr>
                                <th scope="col"></th>
                                <th scope="col" onClick={sortManagersTotals}>Net</th>
                                {sortedPayoutYears.map((payoutYear) => (
                                    <th key={payoutYear} scope="col" onClick={sortByYear(payoutYear)}>{payoutYear}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {managers.map((playerName) => (
                                <tr key={`${playerName}-row`}>
                                    <th scope="row">{playerName}</th>
                                    <td className={totalPayouts[playerName] > 0 ? 'text-success' : 'text-danger'}>{totalPayouts[playerName]}</td>
                                    {sortedPayoutYears.map((payoutYear) => (
                                        <td key={`${playerName}-${payoutYear}`} className={payouts[payoutYear][playerName] > 0 ? 'text-success' : 'text-danger'}>{payouts[payoutYear][playerName]}</td>
                                    ))}
                                </tr>
                            ))}
                            <tr>
                                <th>Totals</th>
                                <td>{Object.keys(totalPayouts).reduce((acc, cur) => (acc + totalPayouts[cur]), 0)}</td>
                                {sortedPayoutYears.map((payoutYear) => (
                                    <td key={`net-${payoutYear}`}>{Object.keys(payouts[payoutYear]).reduce((acc, cur) => acc + payouts[payoutYear][cur], 0)}</td>
                                ))}
                            </tr>
                        </tbody>
                    </table>
                </div>
            }
        </div>
    );
}

export default Payouts;